import MessagePrompter, { SpecificErrors } from "client/components/prompts/MessagePrompter";
import store, { StoreActions } from "client/state/store";
import { Save } from "client/interfaces/Responses";
import { IProjectInfo } from "common/lib";
import AnalyticsManager from "client/classes/AnalyticsManager";
import Scenario from "client/classes/scenarioElements/Scenario";
import StandbyOverlay from "client/components/layout/StandbyOverlay";
import { ProjectStates } from "client/interfaces/ProjectStates";
import ModalManager from "client/components/layout/ModalManager";
import ProjectLoadingDialog from "client/components/dialog/ProjectLoadingDialog";
import ProjectLoader from "client/classes/ProjectLoader";
import ScenarioLoader from "../ScenarioLoader";

export function openSaveFile(save: Save, projectData: IProjectInfo)
{
	if (!save)
	{
		MessagePrompter.showError(SpecificErrors.Error20003_ScenarioLoadFailed);
		return;
	}

	AnalyticsManager.managedEvent('openScenario');
	StandbyOverlay.startStandbyMode("Loading Project");

	store.dispatch(StoreActions.scenario.setScenario(new Scenario(projectData).id));
	store.dispatch(StoreActions.assets.setProjectAssets(save.assets));
	store.dispatch(StoreActions.scenario.setProjectState(projectData.state as ProjectStates));
	store.dispatch(StoreActions.scenario.setProjectSaveFileId(save.revisionId));
	const projectLoader = new ScenarioLoader();
	const loaderModalId = ModalManager.addModal({
		allowClickOut: false,
		content: <ProjectLoadingDialog
			staticWidth={false}
			loader={projectLoader as unknown as ProjectLoader}
			projectName={projectData.name}
		/>
	});
	projectLoader.loadScenario(save.url, projectData).then(() =>
	{
		ModalManager.removeModal(loaderModalId);
	});
}